import { SmDrawer } from '@smiles/smiles-react-design-system';
import React, { useCallback, useEffect, useState } from 'react';

import useEvent from '@/hooks/useEvent';
import useApi from '@/hooks/useApi';

import { getModalContent } from '@/services/requests/Liferay/getModalContent';
import { TModalContent } from '@/services/requests/Liferay/types';
import { getProdConfigData } from '@/services/requests/ProductConfig/getProductConfig';
import { TProductResponse } from '@/services/requests/ProductConfig/types';

import { ScreenDashboard } from './Screen/Dashboard';
import { ScreenLoading } from './Screen/Loading';

export type TScreens = 'dashboard' | 'loading';

const MODAL_CONTENT_NAME = 'modal_cobranded_partners';

export function Modal() {
  const { ApiModal, ApiProduct } = useApi();
  const event = useEvent();

  const [screen, setScreen] = useState<TScreens>('loading');
  const [contentData, setContentData] = useState<TModalContent>();
  const [productData, setProductData] = useState<TProductResponse>();

  const handlerClose = useCallback(() => {
    setScreen('dashboard');
    event.close();
  }, [event]);

  const renderContent = () => {
    const screens = {
      dashboard: !!contentData && !!productData && (
        <ScreenDashboard
          onClose={handlerClose}
          data={contentData}
          productData={productData}
        />
      ),
      loading: <ScreenLoading onClose={handlerClose} />,
    };
    return screens[screen];
  };

  const fetchData = useCallback(async () => {
    const result = await getModalContent(ApiModal, MODAL_CONTENT_NAME);
    setContentData(result);
  }, [ApiModal]);

  const fetchProductData = useCallback(async () => {
    const result = await getProdConfigData(ApiProduct);
    setProductData(result);
  }, [ApiProduct]);

  useEffect(() => {
    if (event.isOpen && !productData && !contentData) {
      fetchProductData();
      fetchData();
    }
  }, [
    contentData,
    event.data.bank,
    event.isOpen,
    fetchData,
    fetchProductData,
    productData,
  ]);

  useEffect(() => {
    if (productData) {
      const bank = validateBankSelected(productData, event.data.bank);
      if (event.data.bank && productData[bank]) {
        window.location.href = productData[bank].keyConfigApi
          ? productData[bank].linkRedirectConfigApi
          : productData[bank].linkRedirect;
      }
    }
  }, [event.data.bank, productData]);

  const validateBankSelected = (obj: TProductResponse, assert: string) => {
    const newAssert = assert === 'bb' ? 'bancodobrasil' : assert;
    const resultKey = Object.keys(obj).find(key => key === newAssert) || '';

    return resultKey as keyof TProductResponse;
  };

  return (
    <>
      <SmDrawer
        className="smls-bank-card-modals"
        isOpen={
          event.isOpen &&
          !!contentData &&
          !!productData &&
          !validateBankSelected(productData, event.data.bank)
        }
        onClose={handlerClose}
      >
        {event.isOpen &&
          productData &&
          contentData &&
          !validateBankSelected(productData, event.data.bank) &&
          renderContent()}
      </SmDrawer>
    </>
  );
}
